import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHotel } from '../../context/hotel-context';
import { useMeeting } from '../meetings/hooks/use-meeting';
import { useStoredData } from '../meetings/hooks/use-stored-data';
import { useTrackMeetingEvent } from '../tracking/hooks/use-track-event';
import { NotFound } from './components/not-found';
import Report from './components/report';
import { ReportLoading } from './components/report-loading';

const SharedReport = () => {
  const { setBrandCode } = useHotel();
  const { meetingId } = useParams<{ meetingId: string }>();
  const { meeting, loadingId } = useMeeting({
    meetingId,
  });
  const { data, fetching } = useStoredData({
    bucket: meeting?.bucket,
    key: meeting?.bucketKey,
    meeting,
  });

  const track = useTrackMeetingEvent({ meeting, page: 'shared_report' });

  useEffect(() => {
    if (meeting) {
      setBrandCode(meeting.brandCode as string);
      track('view_report', 'view_report_loaded');
    }
  }, [meeting]);

  if (!meeting && !loadingId) {
    return (
      <NotFound
        heading={'Meeting not found.'}
        meetingId={meetingId}
        message={'we could not find a meeting with id'}
      />
    );
  }

  if (data?.data && meeting) {
    return (
      <Report data={data} dataLoading={fetching} meeting={meeting} meetingLoading={loadingId} />
    );
  } else {
    return <ReportLoading />;
  }
};

export { SharedReport };
